import { render, staticRenderFns } from "./buyerBehaviorDetail.vue?vue&type=template&id=398cb735&scoped=true&"
import script from "./buyerBehaviorDetail.vue?vue&type=script&lang=js&"
export * from "./buyerBehaviorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398cb735",
  null
  
)

export default component.exports